// Host strony partnera bez „www.”, pokazywany w okienku przed wyjściem (np. axa-assistance.pl)
export const partnerHost = (href) => {
  try {
    return new URL(href).hostname.replace(/^www\./, '');
  } catch (error) {
    return null;
  }
};

// Ctrl/Cmd/Shift/Alt albo środkowy przycisk — użytkownik sam otwiera kartę, okienka nie pokazujemy
export const isModifiedClick = (event) =>
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey ||
  event.button !== 0;
